import sign from 'jwt-encode'
import { StreamChat, User } from 'stream-chat'

async function streamCreateChatClient(
  apiKey: string,
  apiSecret: string,
  userId: string,
  userName: string
) {
  const client = StreamChat.getInstance(apiKey)
  const user: User = {
    user_id: userId,
    user_name: userName,
    id: userId,
    name: userName,
  }

  const userToken = sign(user, apiSecret)
  await client.connectUser(user, userToken)
  return client
}

async function streamCreateChatChannel(
  userId: string,
  channelId: string,
  client: StreamChat
) {
  // await client.deleteChannels([`messaging${channelId}`])
  const channel = client.getChannelById('messaging', channelId, {
    name: 'Nomos IA Chat',
    members: [userId, `${process.env.REACT_APP_GPT_ENTITY_NAME}Id`],
  })
  return channel
}

export { streamCreateChatClient, streamCreateChatChannel }
